import { render, staticRenderFns } from "./CompanyDetial.vue?vue&type=template&id=9c43d9d4&scoped=true"
import script from "./CompanyDetial.vue?vue&type=script&lang=js"
export * from "./CompanyDetial.vue?vue&type=script&lang=js"
import style0 from "./CompanyDetial.vue?vue&type=style&index=0&id=9c43d9d4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c43d9d4",
  null
  
)

export default component.exports